export function _getChapterDomContent($: JQueryStatic)
{
	return $('.container .forum-content')
}
